import AddDocFirmatoView from "./AddDocFirmatoView";
import {useState} from "react";

export default function AddDocFirmatoController({
                                                    idCertificato,
                                                    submitOk,
                                                }) {

    const [files, setFiles] = useState([]);
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState("");

    return (
        <AddDocFirmatoView
            url={process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/documento-firmato/`}
            files={files}
            setFiles={setFiles}
            token={localStorage.getItem('rfi-login')}
            submitOk={submitOk}
            show={show}
            setShow={setShow}
            message={message}
            setMessage={setMessage}
        />
    )

}